import React, { FC } from 'react';

import { Flex, Text } from '@adsk/alloy-react-box';
import Button from '@adsk/alloy-react-button';
import { LogoAutodeskIcon } from '@adsk/alloy-react-icon';
import Portal from '@adsk/alloy-react-portal';

import i18n from '../../utils/i18n';
import FlexCentered from '../FlexCentered';

type OpenInMobileAppProps = {
  onContinueInApp: () => void;
  onContinueInWeb: () => void;
};

const OpenInMobileApp: FC<OpenInMobileAppProps> = ({
  onContinueInApp,
  onContinueInWeb,
}) => {
  return (
    <Portal>
      <Flex
        flexDirection="column"
        justifyContent="space-between"
        padding={16}
        backgroundColor="white"
        width="100%"
        height="100%"
        position="fixed"
      >
        <div data-testid="OpenInMobileAppSpacer" />
        <FlexCentered flexDirection="column">
          <LogoAutodeskIcon size={90} style={{ marginBottom: 48 }} />
          <Text
            marginBottom="8px"
            marginTop="0px"
            fontWeight={700}
            typography="heading1"
          >
            {i18n.t('OPEN_IN_MOBILE_APP_TITLE')}
          </Text>
          <Text typography="bodyLarge">
            {i18n.t('OPEN_IN_MOBILE_APP_SUBTITLE')}
          </Text>
        </FlexCentered>
        <Flex
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          justifySelf="flex-end"
          style={{ gap: 8 }}
        >
          <Button
            onClick={onContinueInApp}
            style={{ width: '100%', height: 48 }}
            variant="primary"
          >
            {i18n.t('CONTINUE_IN_APP')}
          </Button>
          <Button
            onClick={onContinueInWeb}
            style={{ width: '100%', height: 48 }}
          >
            {i18n.t('CONTINUE_IN_WEB')}
          </Button>
        </Flex>
      </Flex>
    </Portal>
  );
};

export default OpenInMobileApp;
